import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  Account,
  ActionFailed,
  Channel,
  ConfirmDialogService,
  Destroyable,
  SaveForm,
  selectCurrentAccount,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { Actions, ofType } from '@ngrx/effects'
import { select, Store } from '@ngrx/store'

import {
  ConnectHopper,
  ConnectHopperSuccess,
  DisconnectHopper,
  HopperStatus,
  selectHopperStatus,
} from '@tokeet-frontend/channels'

import { UserStorage } from '@tokeet-frontend/tv3-platform'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ChannelConnectHelperService } from '../../channel-connect-helper.service'
import { combineLatest } from 'rxjs'
@Component({
  selector: 'app-connect-hopper-wizard-step1',
  templateUrl: './connect-hopper-wizard-step1.component.html',
  styleUrls: ['./connect-hopper-wizard-step1.component.scss'],
  providers: [ChannelConnectHelperService],
})
export class ConnectHopperWizardStep1Component extends Destroyable implements OnInit {
  @Output() next = new EventEmitter()
  @Input() channel: Channel

  form = this.fb.group({
    name: ['', [Validators.required, Validators.minLength(5)]],
    email: ['', [Validators.required, Validators.email]],
  })

  isConnecting = false
  status?: HopperStatus
  account: Account

  constructor(
    private fb: FormBuilder,
    private actions: Actions,
    protected storage: UserStorage,
    private store: Store<any>,
    private confirm: ConfirmDialogService
  ) {
    super()
  }

  ngOnInit() {
    this.actions.pipe(ofType(ConnectHopperSuccess), untilDestroy(this)).subscribe(() => {
      this.next.emit()
      this.isConnecting = false
    })
    this.actions.pipe(ofType(ActionFailed), untilDestroy(this)).subscribe(() => {
      this.isConnecting = false
    })

    combineLatest([this.store.select(selectCurrentAccount), this.store.select(selectHopperStatus)])
      .pipe(untilDestroy(this))
      .subscribe(([acc, status]) => {
        this.account = acc
        this.status = status
        this.form.patchValue({
          name: acc.name || '',
          email: status?.email || acc.email || '',
        })
      })
  }

  @SaveForm()
  onNext(form: FormGroup) {
    this.next.emit()
  }

  @SaveForm()
  onConnect(form: FormGroup) {
    this.store.dispatch(ConnectHopper(this.form.getRawValue()))
    this.isConnecting = true
  }

  onDisconnect() {
    this.confirm
      .confirm({
        title: $localize`Disconnect?`,
        body: $localize`Are you sure you want to disconnect Hopper?`,
      })
      .subscribe(() => {
        this.store.dispatch(DisconnectHopper())
      })
  }
}
